"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSelectableTextInputData = void 0;
const generateSelectableTextInputData = (minValue, maxValue, is12Hours, isIgnored) => {
    const data = [];
    if (is12Hours) {
        data.push('12');
    }
    for (let value = minValue; value <= maxValue; value++) {
        if ((isIgnored === null || isIgnored === void 0 ? void 0 : isIgnored(value)) || (is12Hours && value === 12)) {
            continue;
        }
        data.push(`${value}`);
    }
    return data;
};
exports.generateSelectableTextInputData = generateSelectableTextInputData;
//# sourceMappingURL=generateSelectableTextInputData.js.map